import type { FormEvent } from "react";
import { EmailOtpForm } from "../../../components/auth/EmailOtpForm";
import { OTP_CODE_LENGTH } from "../../../domains/auth/hooks/useEmailOtp";
import type { OtpFailureReason } from "../../../tools/analytics/domains/onboarding.analytics";

/**
 * The code slide. It carries the same screen the login page does, wrapped in the
 * carousel's shared form so the footer Continue submits it like every other
 * slide — the boxes also submit themselves on the sixth digit, which is what
 * the iOS autofill banner lands on.
 */
export function OtpStep({
  code,
  error,
  isBusy,
  cooldownRemaining,
  onCodeChange,
  onSubmit,
  onResend,
  isActive,
}: {
  code: string;
  error: OtpFailureReason | null;
  isBusy: boolean;
  cooldownRemaining: number;
  onCodeChange: (code: string) => void;
  onSubmit: (code: string) => void;
  onResend: () => void;
  /** This slide is the one on stage. Gates the autofocus, which would otherwise
   * drag the whole carousel here from wherever the user actually is. */
  isActive: boolean;
}) {
  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (code.length === OTP_CODE_LENGTH && !isBusy) onSubmit(code);
  };

  return (
    <form
      id="onboarding-form-otp"
      className="flex flex-1 flex-col w-full"
      onSubmit={handleSubmit}
    >
      <EmailOtpForm
        code={code}
        error={error}
        isBusy={isBusy}
        cooldownRemaining={cooldownRemaining}
        onCodeChange={onCodeChange}
        onComplete={onSubmit}
        onResend={onResend}
        // The carousel's own Back button walks to the slide the address was
        // typed on, so the slide needs no second way there.
        onChangeEmail={null}
        autoFocus={isActive}
      />
    </form>
  );
}
